// extracted by mini-css-extract-plugin
export const assetsAccountDetails = "Table2__assetsAccountDetails__3-4RH";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "Table2__body__ltBlc";
export const bold = "700";
export const cell = "Table2__cell__Ab0yr";
export const cellSimpleStyles = "Table2__cellSimpleStyles__LDZPL";
export const creditAccountDetails = "Table2__creditAccountDetails__A+tSB";
export const debtsAccountDetails = "Table2__debtsAccountDetails__heo4n";
export const down = "Table2__down__i+XkH";
export const footer = "Table2__footer__eHSn3";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "Table2__headerCell__TXi8a";
export const headerRow = "Table2__headerRow__AAHx9";
export const headerTitle = "Table2__headerTitle__45NA3";
export const hidden = "Table2__hidden__H-UtQ";
export const isMobile = "Table2__isMobile__FLpot";
export const medium = "500";
export const pageSizeSelectorWrapper = "Table2__pageSizeSelectorWrapper__RbwOM";
export const regular = "400";
export const row = "Table2__row__zROxA";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortableHeaderCell = "Table2__sortableHeaderCell__8YiXZ";
export const sortingWrapper = "Table2__sortingWrapper__Nj+te";
export const table = "Table2__table__hIMoZ";
export const tableContainer = "Table2__tableContainer__mp7XR";
export const textCenter = "Table2__textCenter__XCsaI";
export const tooltipIconWrapper = "Table2__tooltipIconWrapper__pjeJn";
export const transactions = "Table2__transactions__-VxIQ";
export const up = "Table2__up__zMf7p";
export const white = "Table2__white__+1Vc2";
export const withHelpText = "Table2__withHelpText__O9xaj";